import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="mx-auto grid max-w-md place-items-center px-5 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle size={44} weight="duotone" className="text-muted-foreground" />
      <h1 className="mt-4 font-heading text-2xl font-light">Contribution cancelled</h1>
      <p className="mt-2 text-sm text-muted-foreground">No worries — you weren't charged. You can support AlumniPulse™ any time.</p>
      <Link to="/support"><Button className="mt-6 rounded-full">Back to Support</Button></Link>
    </div>
  );
}
